import type { IconDefinition } from '../index.tsx';

export const iconGavel: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconGavel',
  icon: [
    16,
    16,
    [],
    '',
    'M11.6214 12.269L12.5983 11.2921L15.0232 8.86727L16 7.89037L13.9847 5.87512C13.4452 6.41462 12.5705 6.41462 12.031 5.87512L10.1279 3.97202C9.58843 3.43252 9.58843 2.55782 10.1279 2.01833L8.10961 7.75502e-06L3.73099 4.37862L5.74931 6.39694C6.28884 5.85742 7.1704 5.86424 7.70992 6.40377L1.07097 13.0427L2.95735 14.9291L9.5963 8.29015C10.1358 8.82967 10.1456 9.71422 9.60612 10.2537L11.6214 12.269Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
